import './Login.scss'
import './ShowPassword.scss'

import React, {Component} from 'react'
import { Button, Input } from 'react-bootstrap'
import Select from 'react-select'
import Alert from 'common/views/atoms/Alert/Alert'
import RdcBrandedLogo from './RdcBrandedLogo'


import { login } from 'common/redux/auth'
import handleSubdomainRedirect from 'common/util/subdomain'

class Login extends Component {

    constructor(props) {
      super(props)
      this.state = {
        username: '',
        password: '',
        type: 'password',
        usernameError: '',
        passwordError: '',
        selectedAccount: '',
      }
      this.handleSubmit = this.handleSubmit.bind(this)
      this.showHide = this.showHide.bind(this);
    }

    handleSubmit(e) {
      e.preventDefault()
      const isValid = this.validate()
      if (isValid) {
        const broker_op_id = this.state.selectedAccount && this.state.selectedAccount.value.broker_op_id
        this.props.dispatch(login(this.state.username, this.state.password, broker_op_id))
        }
    }

    showHide(e){
      e.preventDefault();
      e.stopPropagation();
      this.setState({
        type: this.state.type === 'password' ?  'input' : 'password'
      })
    }

    validate = () => {
      let usernameError=''
      let passwordError=''

      if (this.state.password.length < 1) {
        passwordError = 'Not a valid email password combo'
      }
      //currently removing email validation to allow non-email users to access the portal. Just keeping the commented part, so that in future if we decided to use only email as a username.
      // if (!this.state.username.includes('@')) {
      //   usernameError = 'Not a valid email password combo'
      // }

      if (!this.state.username || !this.state.username.length) {
        usernameError = 'Not a valid email password combo'
      }
      if (usernameError || passwordError) {
        this.setState({ usernameError, passwordError })
        return false
      }
      return true
    }

    render() {
      if (handleSubdomainRedirect()) {
        return (null)
      }

      const {username, password, usernameError, passwordError, selectedAccount} = this.state
      const multiple_accounts = this && this.props && this.props.auth && this.props.auth.multiple_accounts ? this.props.auth.multiple_accounts : null
      const isEnabled = username.length > 1 && password.length > 1
      const borderColorIfValidationFails = usernameError || passwordError ? "password__input invalid" : "password_input"
      const labelColorIfValidationFails =  usernameError || passwordError ? "password invalid" : "password"

      const handleBrokerSelect = (selectedValue) => {
        console.log("selectedValue", selectedValue)
        this.setState({selectedAccount: selectedValue})
      }

      let selectOptions = [{company: "Please choose an account", broker_op_id: null}]
      if (multiple_accounts) {
        selectOptions.push(...multiple_accounts)
      }

      const AccountDropdown = () => {
          return (<Select
              className={"selectStyle"}
              value={selectedAccount}
              onChange={handleBrokerSelect}
              clearable={false}
              searchable={false}
              options={multiple_accounts.map(account => {
                return {value: account, label: account.company}
              })}
              />
          )
      }

      return (
        <div className='Login'>
          <form name="login-form" onSubmit={this.handleSubmit}>
            <RdcBrandedLogo />
            <div className="Login__subtitle">{multiple_accounts? "Select an Account": "Welcome!"}</div>
              <div className='login-inner'>
              {multiple_accounts ? <AccountDropdown/> :
              <div>
                <label className={labelColorIfValidationFails}>Email
                  <input
                    type="text"
                    placeholder="email address"
                    className={borderColorIfValidationFails}
                    value={this.state.username}
                    onChange={(e) => this.setState({username:e.target.value})}>
                  </input>
                </label>
                <label className={labelColorIfValidationFails}>
                  <div>Password</div>
                  <input
                    name="password-input"
                    type={this.state.type}
                    placeholder="password"
                    className={borderColorIfValidationFails}
                    value={this.state.password} onChange={(e) => this.setState({password:e.target.value})}>
                  </input>
                  { (this.state.password.length > 0) ?
                    <div
                      className="password__show"
                      onClick={this.showHide}>
                      {this.state.type === 'input' ?
                        < i className="fa fa-eye-slash fa-lg"></i>
                        :  <i className="fa fa-eye fa-lg"></i>
                      }
                    </div>
                    : null
                  }
                </label>
              </div>
              }
              </div>
              {(this.state.usernameError || this.state.passwordError) ? (
                <div name="error-login-color" style ={{ fontsize: 10, marginTop: -20,  color: '#D92228'}}>
                  {this.state.usernameError}
                </div>
                ) : null}
            <Alert type="danger" errorText={this.props.auth && this.props.auth.error ? "Invalid Username or Password" : ""} />
          <div>
            {isEnabled ? <Button bsClass="Login__login_button_active"  type="submit">Log in </Button> :
              <Button bsClass="Login__login_button"  type="submit"> Log in
              </Button>
            }
          </div>
            <div className="Login__forgot"><a href="/reset_password" className="Login__forgot__link">Forgot password?</a>
            </div>
          </form>
        </div>
      )
    }
}

export default Login
